<template>
  <v-select
    :label="$t(label)"
    :name="id"
    :id="id"
    :value="value"
    :items="items"
    ref="native"
    @input="v => $emit('input', v)"
    :disabled="disabled"
    :rules="rules"
    validate-on-blur
  >
  </v-select>
</template>

<script>
export default {
  name: 'SelectField',
  props: {
    id: String,
    label: [Object, String],
    disabled: Boolean,
    value: [String, Number],
    options: [Array],
    description: [Object, String],
    rules: Array
  },
  data() {
    return {
      model: null
    }
  },
  computed: {
    items() {
      console.log('O', this.options);
      return (this.options || []).map(option => ({
        value: option.value || option,
        text: option.label && this.$t(option.label) || option.value || option
      }));
    }
  }
}
</script>
